module.exports = __webpack_public_path__ + "img/ca_logo_general.89f5c270.png";